import React from 'react'
import { FormattedMessage } from 'react-intl'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import clsx from 'clsx'
import useHasMounted from 'hooks/useHasMounted'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
interface Props {
  availableRoomCount: number
}

function OfferUrgencyRoomCount(props: Props) {
  const {
    availableRoomCount,
  } = props

  const hasMounted = useHasMounted()

  const croPopularOptionBookingRemaining = !!useOptimizelyExperiment(OptimizelyExperiments.croPopularOptionBookingRemaining)
  if (!croPopularOptionBookingRemaining) {
    return null
  }

  return <UrgencyLabel
    className={clsx({ 'not-mounted': !hasMounted })}
    variant="critical2"
  >
    <FormattedMessage
      id="3pACN79zGC"
      defaultMessage="Guest favourite – {count, plural, one {# room} other {# rooms}} left"
      description="Urgency label showing limited room availability on offer card"
      values={{ count: availableRoomCount }}
    />
  </UrgencyLabel>
}

export default OfferUrgencyRoomCount
